<template>
  <ListLayout
    :title="`${fleetModule.vehiclePlural}`"
    :tableData="vehicleList"
    :tableHeader="tableHeaders"
    :total="totalItems"
    :context="context"
    @getList="getVehicleList"
    :tableScrollable="false"
    localStorageKey="vehicle_columns"
    :isColumnShowVisibility="true"
    ref="listTable"
  >
    <template #listAction>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <SecondaryButton
            id="vehiclesExport"
            v-if="permissions && permissions.view"
            btnClass="mr-2 rounded-lg"
            iconClass="secondary--text mr-2"
            iconSize="lg"
            outlined
            v-bind="attrs"
            v-on="on"
            icon="mdi-download"
            name="Export"
          >
          </SecondaryButton>
        </template>
        <v-list dense flat>
          <v-list-item
            v-if="permissions && permissions.view"
            id="export-vehicle-sheet"
            @click="downloadSheet('Vehicle')"
          >
            <v-list-item-title
              >Export {{ fleetModule.vehicle }} Sheet</v-list-item-title
            >
          </v-list-item>
          <!-- <v-list-item @click="downloadSheet('Vehicle Tags')">
              <v-list-item-title>Export Vehicle Tag Sheet</v-list-item-title>
            </v-list-item> -->
        </v-list>
      </v-menu>
      <v-menu offset-y v-if="permissions && permissions.add">
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <div v-on="{ ...tooltip }">
                <PrimaryButton
                  id="vehiclesAdd"
                  :disabled="isButtonDisabled"
                  v-bind="attrs"
                  v-on="{ ...menu }"
                  :name="`Add ${fleetModule.vehicle}`"
                  icon="mdi-plus"
                  iconSize="lg"
                >
                </PrimaryButton>
              </div>
            </template>
            <span>{{ buttonTooltip }}</span>
          </v-tooltip>
        </template>
        <v-list dense flat>
          <v-list-item id="add-vehicle" @click="$router.push({ name: 'add-vehicle' })">
            <v-list-item-title>Add {{ fleetModule.vehicle }}</v-list-item-title>
          </v-list-item>
          <v-list-item id="import-vehicle" @click="showBulkUploadDialog = true">
            <v-list-item-title
              >Import {{ fleetModule.vehicle }}</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <template #rightFilterSlot>
      <div class="d-flex align-center justify-end w-100">
        <RefreshListButton
          id="vehiclesRefreshList"
          :isIcon="false"
          @click="$refs.listTable.searchTriggered()"
        />
        <VehicleFilter
          :filter="vehicleFilters"
          @apply="
            $refs.listTable.itemsPerPageChanged($globalConstant.itemsPerPage)
          "
          @reset="resetFilter"
          :isChips="isChipsVisible"
        />
      </div>
    </template>
    <template #dialogs>
      <ViewVehicle v-model="openVehicleDetail" :id="selectedId" />
      <DownloadSheet
        v-model="openDownloadDialog"
        :title="downloadTitle"
        :module="downloadModule"
        :method="downloadMethod"
      />
      <BulkUpload
        uploadTo="vehicle"
        v-model="showBulkUploadDialog"
        :hasBulkActions="true"
        @refreshList="
          checkSubscriptionLimit();
          $refs.listTable.itemsPerPageChanged($globalConstant.itemsPerPage);
        "
      />
      <TagListForm
        v-model="showTagComponent"
        :parentObj="selectedVehicleObject"
        tagType="Vehicle"
      />
      <DocumentListForm
        moduleType="Vehicle"
        v-model="documentUploadFormDialog"
        :parentObj="vehicleDetail"
      />
      <VehicleStatusUpdateForm
        v-model="openVehicleStatusUpdateDialog"
        :vehicleObject="vehicleDetail"
        @refreshList="$refs.listTable.searchTriggered()"
      />
    </template>
  </ListLayout>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import VehicleButton from "@/components/Button/VehicleButton.vue";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import ViewVehicle from "@/pages/client/vehicle/ViewVehicle.vue";
import DownloadSheet from "@/components/GeneralComponents/DownloadSheet.vue";
import BulkUpload from "@/components/BaseComponents/BulkUpload.vue";
import VehicleFilter from "@/components/ModuleBasedComponents/Vehicle/VehicleFilter.vue";
import VehicleStorageTypeChip from "@/components/ModuleBasedComponents/Vehicle/VehicleStorageTypeChip.vue";
import TagListForm from "@/components/GeneralComponents/TagListForm.vue";
import VehicleActiveStatus from "@/components/ModuleBasedComponents/Vehicle/VehicleActiveStatus.vue";
import DocumentListForm from "@/components/GeneralComponents/DocumentListForm.vue";
import RefreshListButton from "@/components/BaseComponents/RefreshListButton.vue";
import VehicleStatusUpdateForm from "./VehicleStatusUpdateForm.vue";
import { mapState } from "vuex";
import { filterModules } from "@/utils/fieldConstants";
import { fleetModule } from "@/utils/moduleMapping";

export default {
  components: {
    VehicleButton,
    ListLayout,
    ViewVehicle,
    DownloadSheet,
    BulkUpload,
    VehicleFilter,
    VehicleStorageTypeChip,
    TagListForm,
    VehicleActiveStatus,
    DocumentListForm,
    RefreshListButton,
    VehicleStatusUpdateForm,
  },
  data() {
    return {
      fleetModule,
      openVehicleStatusUpdateDialog: false,
      openDownloadDialog: false,
      sorting: {},
      permissions: null,
      pageNo: 1,
      totalItems: 0,
      isChipsVisible: false,
      vehicleList: [],
      openVehicleDetail: false,
      selectedId: null,
      headerSelected: [
        {
          headerName: "Vehicle Number",
          field: "vehicle_number",
          sortable: true,
          pinned: "left",
          minWidth: 200,
        },
        {
          headerName: "Branch",
          field: "branch",
          sortable: true,
        },
        {
          headerName: "Tonnage Capacity",
          field: "tonnage_capacity",
          sortable: true,
        },
        {
          headerName: "CBM Capacity",
          field: "cbm_capacity",
          sortable: true,
        },
        {
          headerName: "storage type",
          field: "storage_type",
          sortable: true,
          cellRenderer: "VehicleStorageTypeChip",
        },
        {
          headerName: "Fuel Type",
          field: "fuel_type",
          sortable: true,
        },
        {
          headerName: "Odometer Reading",
          field: "odometer_reading",
          sortable: true,
        },
        {
          headerName: "Status",
          field: "is_active",
          sortable: true,
          cellRenderer: "VehicleActiveStatus",
        },
      ],

      isEditing: false,
      showVehicleForm: false,
      selectedVehicleID: null,

      showBulkUploadDialog: false,

      showTagComponent: false,
      selectedVehicleObject: {},
      vehicleTagList: [],

      downloadTitle: null,
      downloadModule: null,
      downloadMethod: null,
      documentUploadFormDialog: false,
      vehicleDetail: {},

      isButtonDisabled: false,
      buttonTooltip: "Add Vehicles",
    };
  },
  computed: {
    tableHeaders() {
      return [
        ...this.headerSelected,
        {
          headerName: "Actions",
          field: "actions",
          sortable: false,
          pinned: "right",
          minWidth: 250,
          maxWidth: 250,
          width: 250,
          cellRenderer: "VehicleButton",
        },
      ];
    },
    context() {
      return { parentComponent: this };
    },
    profileObject() {
      let obj = localStorage.getItem("user_data");
      return obj ? JSON.parse(obj) : null;
    },
    ...mapState("userProfile", {
      vehicleFilters: (state) => state.vehicle_filters,
    }),
  },
  methods: {
    checkSubscriptionLimit() {
      this.$api.company
        .checkSubscriptionLimit(this.profileObject.company, {
          module: "vehicle",
        })
        .then(() => {
          this.isButtonDisabled = false;
          return true;
        })
        .catch((err) => {
          bus.$emit("showToastMessage", {
            message: err.data.non_field_errors[0],
            color: "error",
            timeout: 4000,
          });
          this.isButtonDisabled = true;
          this.buttonTooltip = err.data.non_field_errors[0];
          return false;
        });
    },
    openVehicleStatusUpdate(data) {
      this.vehicleDetail = data;
      if (data && data.is_active) {
        this.openVehicleStatusUpdateDialog = true;
      } else {
        this.updateVehicleStatusDetails();
      }
    },
    updateVehicleStatusDetails() {
      bus.$emit("showLoader", true);
      this.$api.vehicle
        .updateVehicleStatus(this.vehicleDetail.id, { status: "active" })
        .then(() => {
          bus.$emit("showToastMessage", {
            message: "Vehicle Status updated successfully!",
            color: "green",
          });
          this.getVehicleList();
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
        });
    },
    downloadSheet(type) {
      if (type == "Vehicle") {
        this.downloadTitle = "Export Vehicles";
        this.downloadModule = "vehicle";
        this.downloadMethod = "downloadVehicleSheet";
      }
      if (type == "Vehicle Tags") {
        this.downloadTitle = "Export Vehicles Tags ";
        this.downloadModule = "vehicleTags";
        this.downloadMethod = "downloadVehicleTagsSheet";
      }
      this.openDownloadDialog = true;
    },
    resetFilter() {
      this.$store.commit("userProfile/resetFilters", {
        moduleKey: "vehicle_filters",
      });
      this.getVehicleList({ limit: 10, offset: 0 });
    },
    getViewDetail(id) {
      this.$router.push({ name: "vehicle-detail", params: { id: id } });
    },
    addTagsForVehicle(vehicleObj) {
      this.selectedVehicleObject = vehicleObj;
      this.showTagComponent = true;
    },
    getDocumentList(data) {
      this.vehicleDetail = data;
      this.documentUploadFormDialog = true;
    },
    async getVehicleList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        ...this.vehicleFilters,
      };

      await this.$store.dispatch("userProfile/updateUserFilters", {
        filter_data: { ...this.vehicleFilters },
        filter_type: filterModules.VEHICLE,
      });

      this.isChipsVisible = Object.keys(this.vehicleFilters).length > 0;

      this.$api.vehicle
        .getVehicleList(params)
        .then((res) => {
          this.vehicleList = res.data;
          this.totalItems = res.count;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  created() {
    this.permissions = this.$permissions.getPermission("fleet");
    this.checkSubscriptionLimit();
  },
};
</script>
